import React from 'react';
import { getProductPhoto } from '../../data/brandImages';
import { formatRewardDeal, getRewardTerms, money } from '../../utils/loyalty';

const BenefitCard = ({
  reward,
  index = 0,
  cta,
  onAction,
  faltan,
  compact = false,
  horizontal = false,
}) => {
  const { puntos, plata } = getRewardTerms(reward);
  const name = reward.nombre || reward.name || 'Beneficio';
  const img = reward.image || getProductPhoto(index);

  if (horizontal) {
    return (
      <article className="rounded-2xl overflow-hidden bg-white border border-gray-100 flex items-stretch shadow-sm">
        <div className="w-28 flex-shrink-0 relative">
          <img src={img} alt={name} className="w-full h-full object-cover" style={{ minHeight: 96 }} />
          {faltan > 0 && (
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <span className="text-white text-xs font-black text-center leading-tight px-1">
                Te faltan<br />{money(faltan)} pts
              </span>
            </div>
          )}
        </div>
        <div className="p-3 flex flex-col justify-between flex-1 min-w-0">
          <div>
            <h3 className="font-black text-sm leading-tight line-clamp-2">{name}</h3>
            <p className="text-maja-red font-black mt-1 text-xs">
              {money(puntos)} pts <span className="text-gray-400">+</span> ${money(plata)}
            </p>
          </div>
          {cta && (
            <button
              type="button"
              onClick={onAction}
              className="mt-2 h-8 w-full rounded-full bg-maja-red text-white text-xs font-black"
            >
              {cta}
            </button>
          )}
        </div>
      </article>
    );
  }

  return (
    <article className="rounded-2xl overflow-hidden bg-white border border-gray-100 flex flex-col shadow-sm">
      <img
        src={img}
        alt={name}
        className={`w-full object-cover ${compact ? 'h-36' : 'h-40'}`}
      />
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-black text-lg leading-tight">{name}</h3>
        <p className="text-maja-red font-black mt-2 text-base">
          {money(puntos)} pts <span className="text-gray-400 font-extrabold">+</span> ${money(plata)}
        </p>
        {faltan > 0 && (
          <p className="text-sm text-gray-500 mt-1">Te faltan {money(faltan)} puntos</p>
        )}
        {cta && (
          <button
            type="button"
            onClick={onAction}
            className="mt-4 h-11 w-full rounded-full bg-maja-red text-white text-sm font-black"
          >
            {cta}
          </button>
        )}
      </div>
    </article>
  );
};

export default BenefitCard;
